import React from 'react'
import Services from '../components/Services/Services'
import '../scss/pages/ServicesPage.scss'
import Footer from '../components/utils/Footer'
const ServicesPage = () => {
  return (
    <>
    <Services/>
    <Footer/>
    </>
  )
}

export default ServicesPage